module.exports = __webpack_public_path__ + "static/img/righte9873ed.png";